'use client';

import { useCallback } from 'react';

import { postAdEventReq } from '../api';
import type { AdEventType } from '../types';
import { getAdSessionId } from '../utils';

export const useTrackAdEvent = () => {
  const trackAdEvent = useCallback(async (campaignId: number, eventType: AdEventType) => {
    const sessionId = getAdSessionId();

    if (!sessionId) {
      return { success: false };
    }

    return postAdEventReq(campaignId, eventType, sessionId);
  }, []);

  return { trackAdEvent };
};
